import React from 'react';
import { SvgIcon } from '@mui/material';
import { parseColor } from '../theme/materialTheme';

// export const IconName = (props) => <SvgIcon {...props}></SvgIcon>;

export const NavbarMessages = ({ cart, fill, outline, ...props }) => (
  <SvgIcon
    width="32.605"
    height="34.019"
    viewBox="0 0 32.605 34.019"
    {...props}
  >
    <g transform="translate(-50.557 -9.188)">
      <g transform="translate(3.917)">
        <path
          d="M30.543,3H6.06A3.056,3.056,0,0,0,3.015,6.06L3,33.6l6.121-6.121H30.543a3.069,3.069,0,0,0,3.06-3.06V6.06A3.069,3.069,0,0,0,30.543,3Z"
          transform="translate(44.641 7.186)"
          fill={parseColor(fill) || 'currentColor'}
          opacity="0.2"
        />
        <path
          d="M30.543,3H6.06A3.056,3.056,0,0,0,3.015,6.06L3,33.6l6.121-6.121H30.543a3.069,3.069,0,0,0,3.06-3.06V6.06A3.069,3.069,0,0,0,30.543,3Z"
          transform="translate(44.641 7.188)"
          fill="none"
          stroke={parseColor(outline) || 'currentColor'}
          strokeWidth="2"
        />
      </g>
      <path
        d="M18.655,8.906l1.4-6.148a.709.709,0,0,0-.692-.867H4.706L4.435.567A.709.709,0,0,0,3.74,0H.709A.709.709,0,0,0,0,.709v.473a.709.709,0,0,0,.709.709H2.775L4.851,12.043a1.655,1.655,0,1,0,1.982.253h9.241a1.655,1.655,0,1,0,1.88-.308l.163-.718a.709.709,0,0,0-.692-.867H6.447l-.193-.946H17.963A.709.709,0,0,0,18.655,8.906Z"
        transform="translate(56.825 15.287)"
        fill={parseColor(cart) || 'currentColor'}
      />
    </g>
  </SvgIcon>
);

export const SellerPayment = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="Group_1809" data-name="Group 1809">
      <path
        id="Path_1282"
        data-name="Path 1282"
        d="M0,0H132V132H0Z"
        fill="none"
      />
      <path
        id="Path_1283"
        data-name="Path 1283"
        d="M0,0H132V132H0Z"
        fill="none"
        opacity="0.87"
      />
    </g>
    <path
      id="Path_1284"
      data-name="Path 1284"
      d="M6,65H72V10H6Z"
      transform="translate(27 45)"
      fill="#ff9800"
      opacity="0.3"
    />
    <path
      id="Path_1285"
      data-name="Path 1285"
      d="M81,39.5H75.5v-11a27.5,27.5,0,1,0-55,0v11H15a11.032,11.032,0,0,0-11,11v55a11.032,11.032,0,0,0,11,11H81a11.032,11.032,0,0,0,11-11v-55A11.032,11.032,0,0,0,81,39.5Zm-49.5-11a16.5,16.5,0,1,1,33,0v11h-33Zm49.5,77H15v-55H81Z"
      transform="translate(18 4.5)"
      fill="#0069cf"
    />
    <text
      id="_"
      data-name="$"
      transform="translate(55.074 95)"
      fill="#0069cf"
      fontSize="34"
      fontFamily="Poppins-Bold, Poppins"
      fontWeight="700"
    >
      <tspan x="0" y="0">
        $
      </tspan>
    </text>
  </SvgIcon>
);

export const SellerShineOnline = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="Group_1809" data-name="Group 1809">
      <path
        id="Path_1282"
        data-name="Path 1282"
        d="M0,0H132V132H0Z"
        fill="none"
      />
      <path
        id="Path_1283"
        data-name="Path 1283"
        d="M0,0H132V132H0Z"
        fill="none"
        opacity="0.87"
      />
    </g>
    <g
      id="Group_1873"
      data-name="Group 1873"
      transform="translate(26.1 20.401)"
    >
      <path
        id="Path_1284"
        data-name="Path 1284"
        d="M6,59.039c12.507,12.26,39.017,8.84,52.877-5.13S49.473.618,49.473.618L38.357,6.6,20.689-4.8S9.537,1.894,5.105,9.913C-4.055,27.762-5.119,48.14,6,59.039Z"
        transform="translate(8.918 17.613)"
        fill="#ff9800"
        opacity="0.3"
      />
      <path
        id="FontAwsome_fire-alt_"
        data-name="FontAwsome (fire-alt)"
        d="M57.634,9.12A106.406,106.406,0,0,0,47.62,19.8,138.2,138.2,0,0,0,29.925,0C12.422,16.24,0,37.4,0,50.16,0,72.826,17.864,91.2,39.9,91.2S79.8,72.826,79.8,50.16c0-9.489-9.259-29.059-22.166-41.04ZM61.24,72.947C53.83,80.356,44.55,81.1,39.409,81.1,26.557,81.1,10.3,66.762,10.3,52.956,8.371,36.832,21.289,25.449,29.925,15.1c1.234,1.421,16.5,17.384,16.5,17.384L57.634,19.8c.737,1.22,6.713,11.535,7.312,12.678,2.3,4.388,5.661,12.441,5.416,20.476-.255,8.4-4.49,16.751-9.121,19.991Z"
        fill="#3566ba"
      />
      <path
        id="FontAwsome_fire-alt_2"
        data-name="FontAwsome (fire-alt)"
        d="M23.881,3.779a44.09,44.09,0,0,0-4.149,4.426A57.265,57.265,0,0,0,12.4,0C5.147,6.729,0,15.5,0,20.784A16.774,16.774,0,0,0,16.533,37.789,16.774,16.774,0,0,0,33.065,20.784c0-3.932-3.836-12.041-9.185-17.005ZM22.444,28.921a9.919,9.919,0,0,1-5.7,1.782c-5.325,0-9.658-3.524-9.658-9.244,0-2.85,1.794-5.361,5.372-9.65.511.589,7.294,9.251,7.294,9.251l4.327-4.936c.306.506.584,1,.832,1.474a8.8,8.8,0,0,1-2.467,11.323Z"
        transform="translate(23 45.6)"
        fill="#3566ba"
      />
    </g>
  </SvgIcon>
);

export const SellerEliminateDistractions = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_872"
          data-name="Rectangle 872"
          width="82.703"
          height="81.965"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="lock" transform="translate(0 -0.5)">
      <g id="Group_1811" data-name="Group 1811" transform="translate(0 0.5)">
        <g id="Group_1809" data-name="Group 1809">
          <path
            id="Path_1282"
            data-name="Path 1282"
            d="M0,0H132V132H0Z"
            fill="none"
          />
          <path
            id="Path_1283"
            data-name="Path 1283"
            d="M0,0H132V132H0Z"
            fill="none"
            opacity="0.87"
          />
        </g>
        <g
          id="Group_1874"
          data-name="Group 1874"
          transform="translate(24.999 25)"
        >
          <g id="Group_1875" data-name="Group 1875">
            <g
              id="Group_1874-2"
              data-name="Group 1874"
              clipPath="url(#clip-path)"
            >
              <path
                id="Path_1309"
                data-name="Path 1309"
                d="M97.428,91.3A30.144,30.144,0,1,1,67.284,61.16,30.144,30.144,0,0,1,97.428,91.3"
                transform="translate(-28.808 -47.439)"
                fill="#fbdaa8"
                fillRule="evenodd"
              />
            </g>
          </g>
          <g id="Group_1877" data-name="Group 1877">
            <g
              id="Group_1876"
              data-name="Group 1876"
              clipPath="url(#clip-path)"
            >
              <path
                id="Path_1310"
                data-name="Path 1310"
                d="M38.479,101.881a38.883,38.883,0,0,1-7.74-.776,38.372,38.372,0,0,1-7.213-2.226A38.665,38.665,0,0,1,6.588,85.061,37.711,37.711,0,0,1,.783,71.443,37.616,37.616,0,0,1,3.032,48.969,38.444,38.444,0,0,1,6.588,42.5,38.684,38.684,0,0,1,46.214,26.452,38.444,38.444,0,0,1,59.965,32.2a38.882,38.882,0,0,1,5.7,4.658,38.3,38.3,0,0,1,8.261,12.113,37.657,37.657,0,0,1,0,29.62,38.285,38.285,0,0,1-3.556,6.471,38.568,38.568,0,0,1-31.887,16.82m0-12.07A26.21,26.21,0,0,0,48.69,87.76a26.4,26.4,0,0,0,8.356-5.587,26.072,26.072,0,0,0,3.212-3.854,25.71,25.71,0,0,0,0-29.08,26.013,26.013,0,0,0-3.212-3.854A26.406,26.406,0,0,0,48.69,39.8,26.346,26.346,0,0,0,23.8,42.205a26.492,26.492,0,0,0-3.892,3.181,26.2,26.2,0,0,0-5.645,8.274,25.721,25.721,0,0,0,0,20.236A26.035,26.035,0,0,0,16.7,78.32,26.344,26.344,0,0,0,38.479,89.81"
                transform="translate(0 -19.916)"
                fill="#0069cf"
                fillRule="evenodd"
              />
              <path
                id="Path_1311"
                data-name="Path 1311"
                d="M112.647,154.092a17.069,17.069,0,0,1-15.685-10.3,16.683,16.683,0,0,1,0-13.11,17.087,17.087,0,0,1,9.068-8.979,17.077,17.077,0,0,1,22.3,8.979,16.685,16.685,0,0,1,0,13.11,16.841,16.841,0,0,1-3.655,5.36,17.063,17.063,0,0,1-12.025,4.944m0-8.267a8.711,8.711,0,0,0,7.989-5.251,8.522,8.522,0,0,0,0-6.684,8.7,8.7,0,0,0-15.979,0,8.5,8.5,0,0,0,0,6.684,8.579,8.579,0,0,0,1.862,2.73,8.683,8.683,0,0,0,6.128,2.521"
                transform="translate(-74.169 -93.367)"
                fill="#0069cf"
                fillRule="evenodd"
              />
              <path
                id="Path_1312"
                data-name="Path 1312"
                d="M171.072,87.9a.535.535,0,0,1-.379-.916l31.266-30.954.763.755L171.449,87.74a.535.535,0,0,1-.377.156"
                transform="translate(-132.275 -43.456)"
                fill="#fffffe"
                fillRule="evenodd"
              />
              <path
                id="Path_1313"
                data-name="Path 1313"
                d="M168.291,84.787a1.346,1.346,0,0,1-.514-.1h0a1.341,1.341,0,0,1-.437-.291l0,0v0a1.33,1.33,0,0,1-.387-.949,1.346,1.346,0,0,1,.391-.945h0L198.61,51.537l.568-.562.568.562.763.755.577.571-.577.571-31.273,30.96a1.343,1.343,0,0,1-.432.288h0a1.34,1.34,0,0,1-.513.1"
                transform="translate(-129.493 -39.539)"
                fill="#ff9800"
              />
              <path
                id="Path_1314"
                data-name="Path 1314"
                d="M306.247,15.617a.54.54,0,0,1-.377-.155L298.522,8.19a.537.537,0,0,1,0-.762L305.87.155a.537.537,0,0,1,.908.46L305.571,8.7,313.5,7.283a.537.537,0,0,1,.472.909l-7.348,7.273a.545.545,0,0,1-.376.152"
                transform="translate(-231.426 -0.001)"
                fill="#ff9800"
                fillRule="evenodd"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const SellerTradeShowOnline = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="Group_1811" data-name="Group 1811">
      <g id="Group_1809" data-name="Group 1809">
        <path
          id="Path_1282"
          data-name="Path 1282"
          d="M0,0H132V132H0Z"
          fill="none"
        />
        <path
          id="Path_1283"
          data-name="Path 1283"
          d="M0,0H132V132H0Z"
          fill="none"
          opacity="0.87"
        />
      </g>
    </g>
    <g
      id="Group_1871"
      data-name="Group 1871"
      transform="translate(22.955 22.955)"
    >
      <g
        id="Ellipse_389"
        data-name="Ellipse 389"
        transform="translate(3 3)"
        fill="#fbdaa8"
        stroke="#707070"
        strokeWidth="1"
      >
        <circle cx="40" cy="40" r="40" stroke="none" />
        <circle cx="40" cy="40" r="39.5" fill="none" />
      </g>
      <path
        id="FontAwsome_globe-americas_"
        data-name="FontAwsome (globe-americas)"
        d="M43.046,8A43.046,43.046,0,1,0,86.092,51.046,43.045,43.045,0,0,0,43.046,8ZM57.329,70.069c-.677.673-1.387,1.38-1.963,1.958A4.148,4.148,0,0,0,54.3,73.886c-.262.982-.474,1.975-.828,2.928l-3.018,8.132a34.688,34.688,0,0,1-7.4.814V81.008c.293-2.19-1.326-6.294-3.928-8.9a5.555,5.555,0,0,1-1.626-3.928V62.628a5.536,5.536,0,0,0-2.857-4.855c-2.494-1.38-6.042-3.308-8.472-4.532a25.022,25.022,0,0,1-5.494-3.775l-.139-.125a19.924,19.924,0,0,1-3.135-3.6c-1.628-2.39-4.28-6.321-6-8.876A34.9,34.9,0,0,1,29.3,19.18l4.167,2.085a2.777,2.777,0,0,0,4.02-2.484V16.819a34.687,34.687,0,0,1,4.233-.42l4.912,4.912a2.777,2.777,0,0,1,0,3.928l-.814.812-1.795,1.795a1.389,1.389,0,0,0,0,1.963l.814.814a1.389,1.389,0,0,1,0,1.963l-1.389,1.389a1.39,1.39,0,0,1-.982.406h-1.56a1.388,1.388,0,0,0-.969.394L38.221,36.45a1.39,1.39,0,0,0-.274,1.616l2.706,5.414a1.389,1.389,0,0,1-1.241,2.01h-.979a1.387,1.387,0,0,1-.91-.34l-1.611-1.4a2.78,2.78,0,0,0-2.7-.538l-5.41,1.8a2.075,2.075,0,0,0-.271,3.824l1.923.962a11.755,11.755,0,0,0,5.261,1.243c1.826,0,3.921,4.737,5.554,5.554H51.856a5.558,5.558,0,0,1,3.928,1.626L58.161,60.6a5.294,5.294,0,0,1,1.55,3.744,8.077,8.077,0,0,1-2.381,5.724ZM72.38,54.214a4.166,4.166,0,0,1-2.456-1.731L66.8,47.8a4.161,4.161,0,0,1,0-4.62l3.4-5.1a4.161,4.161,0,0,1,1.6-1.415l2.253-1.126a33.628,33.628,0,0,1,3.385,19.938Z"
        transform="translate(0 -8)"
        fill="#3566ba"
      />
    </g>
  </SvgIcon>
);

export const SellerRobustNetwork = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="Group_1811" data-name="Group 1811">
      <g id="Group_1809" data-name="Group 1809">
        <path
          id="Path_1282"
          data-name="Path 1282"
          d="M0,0H132V132H0Z"
          fill="none"
        />
        <path
          id="Path_1283"
          data-name="Path 1283"
          d="M0,0H132V132H0Z"
          fill="none"
          opacity="0.87"
        />
      </g>
      <g
        id="Group_1872"
        data-name="Group 1872"
        transform="translate(22.002 28.051)"
      >
        <path
          id="Path_1284"
          data-name="Path 1284"
          d="M6,22.934H22.223V10H6Z"
          transform="translate(5.199 40.749)"
          fill="#ff9800"
          opacity="0.3"
        />
        <path
          id="Path_1307"
          data-name="Path 1307"
          d="M6,22.934H22.223V10H6Z"
          transform="translate(55.199 40.749)"
          fill="#ff9800"
          opacity="0.3"
        />
        <path
          id="Path_1308"
          data-name="Path 1308"
          d="M6,22.934H27.5V10H6Z"
          transform="translate(28.199 -3.251)"
          fill="#ff9800"
          opacity="0.3"
        />
        <path
          id="FontAwsome_network-wired_"
          data-name="FontAwsome (network-wired)"
          d="M88,36.3V34.1a2.2,2.2,0,0,0-2.2-2.2H47.3V26.4h9.9A4.4,4.4,0,0,0,61.6,22V4.4A4.4,4.4,0,0,0,57.2,0H30.8a4.4,4.4,0,0,0-4.4,4.4V22a4.4,4.4,0,0,0,4.4,4.4h9.9v5.5H2.2A2.2,2.2,0,0,0,0,34.1v2.2a2.2,2.2,0,0,0,2.2,2.2H16.5V44H8.8a4.4,4.4,0,0,0-4.4,4.4V66a4.4,4.4,0,0,0,4.4,4.4h22A4.4,4.4,0,0,0,35.2,66V48.4A4.4,4.4,0,0,0,30.8,44H23.1V38.5H64.9V44H57.2a4.4,4.4,0,0,0-4.4,4.4V66a4.4,4.4,0,0,0,4.4,4.4h22A4.4,4.4,0,0,0,83.6,66V48.4A4.4,4.4,0,0,0,79.2,44H71.5V38.5H85.8A2.2,2.2,0,0,0,88,36.3ZM35.2,17.6V8.8H52.8v8.8Zm-8.8,44H13.2V52.8H26.4Zm48.4,0H61.6V52.8H74.8Z"
          fill="#3566ba"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BuyerConnected = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <path
      id="FontAwsome_comment_"
      data-name="FontAwsome (comment)"
      d="M48.248,32C21.6,32,0,51.236,0,74.976a39.958,39.958,0,0,0,10.743,27C8.387,112.395.509,121.672.415,121.775a1.763,1.763,0,0,0-.283,1.8,1.479,1.479,0,0,0,1.376.992c12.5,0,21.862-6.57,26.5-10.62a53.019,53.019,0,0,0,20.241,4.008C74.9,117.953,96.5,98.717,96.5,74.976S74.9,32,48.248,32Z"
      transform="translate(17.751 -12.282)"
      fill="#ecd2ad"
      stroke="#0069cf"
      strokeWidth="6"
    />
    <g id="Group_1809" data-name="Group 1809">
      <path
        id="Path_1282"
        data-name="Path 1282"
        d="M0,0H132V132H0Z"
        fill="none"
      />
      <path
        id="Path_1283"
        data-name="Path 1283"
        d="M0,0H132V132H0Z"
        fill="none"
        opacity="0.87"
      />
    </g>
    <path
      id="FontAwsome_bell_"
      data-name="FontAwsome (bell)"
      d="M44.2,36.447c-1.944-2.089-5.58-5.23-5.58-15.522A15.887,15.887,0,0,0,25.75,5.316v-2.1a3.217,3.217,0,1,0-6.434,0v2.1A15.887,15.887,0,0,0,6.446,20.925c0,10.292-3.637,13.433-5.58,15.522A3.143,3.143,0,0,0,0,38.631a3.222,3.222,0,0,0,3.229,3.219H41.837a3.221,3.221,0,0,0,3.229-3.219,3.142,3.142,0,0,0-.866-2.184Zm-37.408.574c2.135-2.814,4.468-7.478,4.48-16.038,0-.02-.006-.038-.006-.058a11.267,11.267,0,1,1,22.534,0c0,.02-.006.038-.006.058.011,8.561,2.345,13.225,4.48,16.038Zm15.74,14.487a6.437,6.437,0,0,0,6.435-6.439H16.1A6.437,6.437,0,0,0,22.533,51.509Z"
      transform="translate(43.465 36.183)"
      fill="#0069cf"
    />
  </SvgIcon>
);

export const BuyerQuicker = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="lock" transform="translate(-55.074)">
      <g id="Group_1811" data-name="Group 1811" transform="translate(55.074)">
        <g id="Group_1809" data-name="Group 1809">
          <path
            id="Path_1282"
            data-name="Path 1282"
            d="M0,0H132V132H0Z"
            fill="none"
          />
          <path
            id="Path_1283"
            data-name="Path 1283"
            d="M0,0H132V132H0Z"
            fill="none"
            opacity="0.87"
          />
        </g>
        <g
          id="FontAwsome_fighter-jet_"
          data-name="FontAwsome (fighter-jet)"
          transform="translate(18.865 75.402) rotate(-45)"
          fill="#ecd2ad"
        >
          <path
            d="M 29.18068504333496 60.04925155639648 L 25.26846504211426 60.04925155639648 L 25.26846504211426 37.67277145385742 L 25.26846504211426 35.67277145385742 L 23.26846504211426 35.67277145385742 L 16.62033271789551 35.67277145385742 L 15.68357276916504 35.67277145385742 L 15.0838794708252 36.39241409301758 L 6.450146675109863 46.75298690795898 L 3.413852214813232 46.75298690795898 L 3.108025550842285 46.44715881347656 L 3.108025550842285 39.67277145385742 L 4.216052532196045 39.67277145385742 L 4.216052532196045 37.67277145385742 L 4.216052532196045 37.45671844482422 L 8.864185333251953 37.45671844482422 L 10.86418533325195 37.45671844482422 L 10.86418533325195 35.45671844482422 L 10.86418533325195 35.08733367919922 L 10.86418533325195 33.32177352905273 L 9.112252235412598 33.1027717590332 L 1.999999046325684 32.21373748779297 L 1.999999046325684 29.83538055419922 L 9.112252235412598 28.94634628295898 L 10.86418533325195 28.72734642028809 L 10.86418533325195 26.9617862701416 L 10.86418533325195 26.59253311157227 L 10.86418533325195 24.59253311157227 L 8.864185333251953 24.59253311157227 L 4.216052532196045 24.59253311157227 L 4.216052532196045 24.37649154663086 L 4.216052532196045 22.37649154663086 L 3.108025550842285 22.37649154663086 L 3.108025550842285 15.60210037231445 L 3.413857698440552 15.29626560211182 L 6.450023651123047 15.29626560211182 L 15.08389186859131 25.6568660736084 L 15.68358612060547 26.37649154663086 L 16.62033271789551 26.37649154663086 L 23.26846504211426 26.37649154663086 L 25.26846504211426 26.37649154663086 L 25.26846504211426 24.37649154663086 L 25.26846504211426 1.999999165534973 L 29.18068695068359 1.999999165534973 L 29.89226531982422 2.901332378387451 L 46.07519912719727 23.39974594116211 L 46.67575836181641 24.16045188903809 L 47.64495849609375 24.16045188903809 L 50.64450454711914 24.16045188903809 L 56.98470687866211 26.27385330200195 L 57.17258453369141 26.33647918701172 L 57.36909103393555 26.36105155944824 L 75.00374603271484 28.56537818908691 C 79.21991729736328 29.50334739685059 82.27170562744141 30.2552661895752 84.33164978027344 30.86361312866211 C 84.52189636230469 30.9197940826416 84.69905090332031 30.97343254089355 84.86417388916016 31.02463150024414 C 84.69905090332031 31.07583236694336 84.52189636230469 31.12947082519531 84.33164978027344 31.1856517791748 C 82.27170562744141 31.79398536682129 79.21991729736328 32.54590606689453 75.00374603271484 33.48387145996094 L 57.36909103393555 35.68821334838867 L 57.17258453369141 35.71278762817383 L 56.98470687866211 35.77541351318359 L 50.64450454711914 37.88881301879883 L 47.64495849609375 37.88881301879883 L 46.67575836181641 37.88881301879883 L 46.07519912719727 38.64952087402344 L 29.89225196838379 59.14793395996094 L 29.18068504333496 60.04925155639648 Z"
            stroke="none"
          />
          <path
            d="M 27.26847839355469 3.999996185302734 L 27.26847839355469 28.37650299072266 L 14.74684906005859 28.37650299072266 L 12.86418151855469 26.11731338500977 L 12.86418151855469 30.4929027557373 L 8.610977172851562 31.02455711364746 L 12.86418151855469 31.55620956420898 L 12.86418151855469 35.93196105957031 L 14.74683380126953 33.67276382446289 L 27.26847839355469 33.67276382446289 L 27.26847839355469 58.04925537109375 L 28.21146774291992 58.04925537109375 L 45.70656967163086 35.88880920410156 L 50.31990814208984 35.88880920410156 L 56.7280158996582 33.75277709960938 L 74.66153717041016 31.5110912322998 C 75.41719055175781 31.3427906036377 76.1343994140625 31.1806812286377 76.81365203857422 31.02462577819824 C 76.1343994140625 30.86857223510742 75.41719055175781 30.70646095275879 74.66153717041016 30.53816032409668 L 56.7280158996582 28.29648590087891 L 50.31990814208984 26.16045761108398 L 45.7065544128418 26.16045761108398 L 28.21147537231445 3.999996185302734 L 27.26847839355469 3.999996185302734 M 5.108016967773438 17.29625701904297 L 5.108016967773438 20.37650299072266 L 6.216049194335938 20.37650299072266 L 6.216049194335938 22.59253311157227 L 9.926856994628906 22.59253311157227 L 5.513282775878906 17.29625701904297 L 5.108016967773438 17.29625701904297 M 6.216049194335938 39.45671844482422 L 6.216049194335938 41.67276382446289 L 5.108016967773438 41.67276382446289 L 5.108016967773438 44.75297927856445 L 5.513404846191406 44.75297927856445 L 9.926918029785156 39.45671844482422 L 6.216049194335938 39.45671844482422 M 21.05242919921875 -3.814697265625e-06 L 36.93412399291992 -3.814697265625e-06 C 38.54989242553711 -3.814697265625e-06 39.88880157470703 0.3635635375976562 39.88880157470703 0.831024169921875 C 39.88880157470703 1.298458099365234 38.54989242553711 1.662025451660156 36.93412399291992 1.662025451660156 L 31.46201705932617 1.662025451660156 L 47.64496994018555 22.16045761108398 L 50.96903228759766 22.16045761108398 L 57.61716842651367 24.37650299072266 L 75.34552001953125 26.59253311157227 C 88.64178466796875 29.54722595214844 88.64178466796875 30.27436447143555 88.64178466796875 31.02462577819824 C 88.64178466796875 31.77490234375 88.64178466796875 32.50204086303711 75.34552001953125 35.45671844482422 L 57.61716842651367 37.67276382446289 L 50.96903228759766 39.88880920410156 L 47.64496994018555 39.88880920410156 L 31.46201705932617 60.38721084594727 L 36.93412399291992 60.38721084594727 C 38.54989242553711 60.38721084594727 39.88880157470703 60.75079345703125 39.88880157470703 61.21824264526367 C 39.88880157470703 61.68567276000977 38.55002975463867 62.04925537109375 36.93412399291992 62.04925537109375 L 21.05242919921875 62.04925537109375 L 21.05242919921875 60.38721084594727 L 23.26847839355469 60.38721084594727 L 23.26847839355469 37.67276382446289 L 16.62033843994141 37.67276382446289 L 7.386909484863281 48.75297927856445 L 2.585433959960938 48.75297927856445 L 1.108016967773438 47.27558135986328 L 1.108016967773438 37.67276382446289 L 2.216049194335938 37.67276382446289 L 2.216049194335938 35.45671844482422 L 8.864181518554688 35.45671844482422 L 8.864181518554688 35.08733367919922 L 0 33.97930145263672 L 0 28.06980895996094 L 8.864181518554688 26.9617805480957 L 8.864181518554688 26.59253311157227 L 2.216049194335938 26.59253311157227 L 2.216049194335938 24.37650299072266 L 1.108016967773438 24.37650299072266 L 1.108016967773438 14.77368545532227 L 2.585433959960938 13.29625701904297 L 7.386772155761719 13.29625701904297 L 16.62033843994141 24.37650299072266 L 23.26847839355469 24.37650299072266 L 23.26847839355469 1.662025451660156 L 21.05242919921875 1.662025451660156 L 21.05242919921875 -3.814697265625e-06 Z"
            stroke="none"
            fill="#0069cf"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const BuyerPayments = (props) => (
  <SvgIcon width="132" height="132" viewBox="0 0 132 132" {...props}>
    <g
      id="Group_2463"
      data-name="Group 2463"
      transform="translate(0 -6777.998)"
    >
      <path
        id="FontAwsome_tachometer-alt_"
        data-name="FontAwsome (tachometer-alt)"
        d="M22.484,32A22.482,22.482,0,0,0,3.049,65.788a2.47,2.47,0,0,0,2.142,1.187H39.776a2.47,2.47,0,0,0,2.142-1.187A22.482,22.482,0,0,0,22.484,32Zm0,5a2.465,2.465,0,0,1,2.367,1.846,4.208,4.208,0,0,0-.269.521l-.72,2.16a2.433,2.433,0,0,1-1.377.469,2.5,2.5,0,0,1,0-5ZM7.495,59.48a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,7.495,59.48Zm3.747-12.491a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,11.242,46.989Zm19.265-5.653L25.719,55.7a4.9,4.9,0,0,1,1.068,6.277H18.18a4.945,4.945,0,0,1,3.983-7.463L26.952,40.15a1.874,1.874,0,0,1,3.554,1.186ZM31.651,45.8l1.212-3.634a2.463,2.463,0,0,1,.863-.174,2.5,2.5,0,1,1,0,5A2.46,2.46,0,0,1,31.651,45.8ZM37.473,59.48a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,37.473,59.48Z"
        transform="translate(43.517 6808.013)"
      />
      <g
        id="Group_1870"
        data-name="Group 1870"
        transform="translate(0 6777.998)"
      >
        <g id="Group_1809" data-name="Group 1809">
          <path
            id="Path_1282"
            data-name="Path 1282"
            d="M0,0H132V132H0Z"
            fill="none"
          />
          <path
            id="Path_1283"
            data-name="Path 1283"
            d="M0,0H132V132H0Z"
            fill="none"
            opacity="0.87"
          />
        </g>
        <g
          id="Group_1870-2"
          data-name="Group 1870"
          transform="translate(22.002 22.015)"
        >
          <g
            id="FontAwsome_user-shield_"
            data-name="FontAwsome (user-shield)"
            transform="translate(-16.5 -10.502)"
            fill="#ecd2ad"
          >
            <path
              d="M 60.46990966796875 96.97364807128906 C 60.4698371887207 96.97364807128906 60.46990585327148 96.97364807128906 60.46982955932617 96.97364807128906 C 59.50832366943359 96.97364044189453 58.55954742431641 96.79611206054688 57.64970397949219 96.44594573974609 C 52.75587844848633 94.53227233886719 47.97178649902344 91.69941711425781 43.42963027954102 88.02577972412109 C 38.6169548034668 84.13333892822266 34.32752990722656 79.48956298828125 30.68049240112305 74.22344207763672 C 26.73490524291992 68.52622222900391 23.65129280090332 62.24401473999023 21.51527976989746 55.55127716064453 C 19.18270492553711 48.24265289306641 17.99999237060547 40.4832878112793 17.99999237060547 32.48873901367188 C 17.99999237060547 29.7778377532959 19.74915504455566 27.33960151672363 22.45618057250977 26.27703857421875 L 57.65049743652344 12.52925682067871 C 58.56013488769531 12.17930507659912 59.51171493530273 12.00186347961426 60.47891616821289 12.00186347961426 C 61.79732894897461 12.00186347961426 62.84003067016602 12.33196353912354 63.34423065185547 12.52872562408447 L 98.54220581054688 26.27793884277344 C 101.246940612793 27.33960151672363 102.99609375 29.7778377532959 102.99609375 32.48873901367188 C 102.99609375 41.26712417602539 101.6309585571289 49.64748764038086 98.93860626220703 57.39702606201172 C 96.57610321044922 64.19712829589844 93.19015502929688 70.53493499755859 88.87480926513672 76.23441314697266 C 85.13531494140625 81.17332458496094 80.78374481201172 85.53833770751953 75.94097137451172 89.20822906494141 C 71.80428314208984 92.34300994873047 67.45066833496094 94.84516143798828 63.35009002685547 96.44449615478516 C 62.71363830566406 96.6864013671875 61.69882202148438 96.97364807128906 60.46990966796875 96.97364807128906 Z"
              stroke="none"
            />
            <path
              d="M 60.47850036621094 13.50186157226562 C 59.69720077514648 13.50186157226562 58.92775344848633 13.64536285400391 58.19128799438477 13.92839050292969 L 23.00424194335938 27.67332458496094 C 20.87548828125 28.5089111328125 19.49998474121094 30.39906311035156 19.49998474121094 32.48875427246094 C 19.49998474121094 40.32832336425781 20.6588134765625 47.93423843383789 22.94425964355469 55.09522247314453 C 25.03502655029297 61.64620971679688 28.05277252197266 67.79454040527344 31.91364288330078 73.36943817138672 C 35.4793701171875 78.51815032958984 39.67127227783203 83.05686950683594 44.37290191650391 86.85948181152344 C 48.79331207275391 90.43465423583984 53.44221496582031 93.18924713134766 58.19036483764648 95.04676055908203 C 58.92703628540039 95.33001708984375 59.69395446777344 95.47364807128906 60.46979904174805 95.47364807128906 C 61.46731567382812 95.47364807128906 62.29159927368164 95.241455078125 62.81071090698242 95.04481506347656 C 66.78232574462891 93.49500274658203 71.00917053222656 91.06351470947266 75.03501892089844 88.01271057128906 C 79.768310546875 84.42579650878906 84.0223388671875 80.15835571289062 87.67892456054688 75.32894897460938 C 91.89926147460938 69.75496673583984 95.21083068847656 63.55617904663086 97.52166748046875 56.90476608276367 C 100.1588973999023 49.31389236450195 101.4960861206055 41.09916687011719 101.4960861206055 32.48875427246094 C 101.4960861206055 30.39906311035156 100.1205902099609 28.50889587402344 97.99642944335938 27.67512512207031 L 62.79888534545898 13.92607879638672 C 62.39297103881836 13.76766204833984 61.55178451538086 13.50190734863281 60.47872924804688 13.50186157226562 L 60.47850036621094 13.50186157226562 M 60.47890472412109 10.50186157226562 C 61.94512939453125 10.50192260742188 63.1511116027832 10.84318542480469 63.88955688476562 11.13136291503906 L 99.08798217773438 24.88075256347656 C 102.3572998046875 26.16402435302734 104.4960861206055 29.15834045410156 104.4960861206055 32.48875427246094 C 104.4960861206055 70.52870941162109 79.56388854980469 91.73330688476562 63.88954162597656 97.84414672851562 C 62.60629272460938 98.33302307128906 60.03972244262695 98.97465515136719 57.10652923583984 97.84414672851562 C 37.49074554443359 90.17503356933594 16.49998474121094 66.58721923828125 16.49998474121094 32.48875427246094 C 16.49998474121094 29.15834045410156 18.63878631591797 26.16402435302734 21.90810394287109 24.88075256347656 L 57.10652923583984 11.13136291503906 C 58.3106803894043 10.66726684570312 59.45780181884766 10.50182342529297 60.47890472412109 10.50186157226562 Z"
              stroke="none"
              fill="#0069cf"
            />
          </g>
          <path
            id="FontAwsome_donate_"
            data-name="FontAwsome (donate)"
            d="M23.176,41.852A20.926,20.926,0,1,0,2.25,20.926,20.923,20.923,0,0,0,23.176,41.852ZM20.942,9.8V8.109a1.666,1.666,0,0,1,1.67-1.67h1.117a1.666,1.666,0,0,1,1.67,1.67v1.71a7.931,7.931,0,0,1,4.326,1.549,1.128,1.128,0,0,1,.121,1.72l-1.64,1.559a1.134,1.134,0,0,1-1.408.1,3.311,3.311,0,0,0-1.791-.513H21.093a1.75,1.75,0,0,0-1.64,1.841,1.818,1.818,0,0,0,1.217,1.771l6.268,1.881a6.3,6.3,0,0,1,4.4,6.046,6.2,6.2,0,0,1-5.946,6.278v1.69a1.666,1.666,0,0,1-1.67,1.67H22.6a1.666,1.666,0,0,1-1.67-1.67v-1.71a7.931,7.931,0,0,1-4.326-1.549,1.128,1.128,0,0,1-.121-1.72l1.64-1.559a1.134,1.134,0,0,1,1.408-.1,3.311,3.311,0,0,0,1.791.513h3.914a1.75,1.75,0,0,0,1.64-1.841A1.818,1.818,0,0,0,25.661,24l-6.268-1.881A6.3,6.3,0,0,1,15,16.077,6.21,6.21,0,0,1,20.942,9.8Z"
            transform="translate(21.359 19.316)"
            fill="#0069cf"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const BuyerOrders = (props) => (
  <SvgIcon width="132" height="132" viewBox="0 0 132 132" {...props}>
    <g id="lock" transform="translate(0 -6.5)">
      <g id="Group_1811" data-name="Group 1811" transform="translate(0 6.5)">
        <circle
          id="Ellipse_390"
          data-name="Ellipse 390"
          cx="3.5"
          cy="3.5"
          r="3.5"
          transform="translate(83 65.003)"
          fill="#ffe0b2"
        />
        <g id="Group_1809" data-name="Group 1809">
          <path
            id="Path_1282"
            data-name="Path 1282"
            d="M0,0H132V132H0Z"
            fill="none"
          />
          <path
            id="Path_1283"
            data-name="Path 1283"
            d="M0,0H132V132H0Z"
            fill="none"
            opacity="0.87"
          />
        </g>
        <path
          id="FontAwsome_piggy-bank_"
          data-name="FontAwsome (piggy-bank)"
          d="M36.4,13.644H54.6c.767,0,1.521.057,2.26.114,0-.043.014-.071.014-.114a13.644,13.644,0,0,0-27.288,0c0,.3.071.583.085.881A27.017,27.017,0,0,1,36.4,13.644Z"
          transform="translate(25.046 29.615)"
          fill="#ff9800"
        />
        <path
          id="FontAwsome_piggy-bank_2"
          data-name="FontAwsome (piggy-bank)"
          d="M79.611,31.837H75.418A22.811,22.811,0,0,0,70.1,24.375l2.686-10.731H68.241a13.558,13.558,0,0,0-10.375,4.875,22.541,22.541,0,0,0-3.269-.327H36.4A22.762,22.762,0,0,0,14.118,36.385H7.978a3.415,3.415,0,0,1-3.34-4.093,3.5,3.5,0,0,1,3.482-2.729h.142a.855.855,0,0,0,.853-.853V25.867a.855.855,0,0,0-.853-.853A8.142,8.142,0,0,0,.09,31.922a7.965,7.965,0,0,0,7.888,9.011h5.685a22.649,22.649,0,0,0,9.1,18.093V70.5a2.281,2.281,0,0,0,2.274,2.274h9.1A2.281,2.281,0,0,0,36.4,70.5V63.673H54.6V70.5a2.281,2.281,0,0,0,2.274,2.274h9.1A2.281,2.281,0,0,0,68.241,70.5V59.026a22.743,22.743,0,0,0,4.449-4.449h6.922A2.281,2.281,0,0,0,81.885,52.3V34.111A2.281,2.281,0,0,0,79.611,31.837Zm-18.192,9.1a2.274,2.274,0,1,1,2.274-2.274A2.281,2.281,0,0,1,61.418,40.933Z"
          transform="translate(25.047 29.615)"
          fill="#0069cf"
        />
      </g>
    </g>
  </SvgIcon>
);

export const BuyerEliminateDistractions = (props) => (
  <SvgIcon
    width="132.001"
    height="132.001"
    viewBox="0 0 132.001 132.001"
    {...props}
  >
    <g id="Group_1811" data-name="Group 1811">
      <circle
        id="Ellipse_388"
        data-name="Ellipse 388"
        cx="31"
        cy="31"
        r="31"
        transform="translate(35.074 35)"
        fill="#ffe0b2"
      />
      <g id="Group_1809" data-name="Group 1809">
        <path
          id="Path_1282"
          data-name="Path 1282"
          d="M0,0H132V132H0Z"
          fill="none"
        />
        <path
          id="Path_1283"
          data-name="Path 1283"
          d="M0,0H132V132H0Z"
          fill="none"
          opacity="0.87"
        />
      </g>
      <path
        id="FontAwsome_crosshairs_"
        data-name="FontAwsome (crosshairs)"
        d="M85.938,38.5H80.719A37.148,37.148,0,0,0,49.5,7.281V2.063A2.063,2.063,0,0,0,47.438,0H40.563A2.063,2.063,0,0,0,38.5,2.063V7.281A37.148,37.148,0,0,0,7.281,38.5H2.063A2.063,2.063,0,0,0,0,40.563v6.875A2.063,2.063,0,0,0,2.063,49.5H7.281A37.148,37.148,0,0,0,38.5,80.719v5.219A2.063,2.063,0,0,0,40.563,88h6.875A2.063,2.063,0,0,0,49.5,85.938V80.719A37.148,37.148,0,0,0,80.719,49.5h5.219A2.063,2.063,0,0,0,88,47.438V40.563A2.063,2.063,0,0,0,85.938,38.5ZM49.5,69.546V62.563A2.063,2.063,0,0,0,47.438,60.5H40.563A2.063,2.063,0,0,0,38.5,62.563v6.984A26.153,26.153,0,0,1,18.454,49.5h6.984A2.063,2.063,0,0,0,27.5,47.438V40.563A2.063,2.063,0,0,0,25.438,38.5H18.454A26.153,26.153,0,0,1,38.5,18.454v6.984A2.063,2.063,0,0,0,40.563,27.5h6.875A2.063,2.063,0,0,0,49.5,25.438V18.454A26.153,26.153,0,0,1,69.546,38.5H62.563A2.063,2.063,0,0,0,60.5,40.563v6.875A2.063,2.063,0,0,0,62.563,49.5h6.984A26.153,26.153,0,0,1,49.5,69.546ZM49.5,44A5.5,5.5,0,1,1,44,38.5,5.5,5.5,0,0,1,49.5,44Z"
        transform="translate(22 22)"
        fill="#0069cf"
      />
    </g>
  </SvgIcon>
);

// export const IconName = (props) => <SvgIcon {...props}></SvgIcon>;
